import { useState, useEffect } from 'react';
import { GetPouchDBData } from '../Utility/pouchdbService';

const usePouchDBData = (key) => {
  const urlparams = new URLSearchParams(window.location.search);
  const uuid = urlparams.get('uuid');
  const [storedData, setStoredData] = useState(() => ({}));
  useEffect(() => {
    const fetchData = async () => {
      const data = await GetPouchDBData(key);
      setStoredData(data === '' ? '' : data ? data : {});
    };
    fetchData();
  }, [key, uuid]);
  return storedData;
};

// If you are expecting a string when using usePouchDBData, you can use this function insted to fetch data from PouchDB and return it as a string if the data is undefined an empty object.
export const usePouchDBDataAsString = (key) => {
  const value = usePouchDBData(key);
  return typeof value === 'object' && Object.keys(value).length === 0
    ? ''
    : value;
};

export default usePouchDBData;
